<template>
  <button
    v-if="ready"
    data-ask-brunon
    data-testid="ask-brunon-button"
    type="button"
    :aria-label="$t('menu.ask_brunon')"
    :aria-expanded="open ? 'true' : 'false'"
    :class="
      header
        ? 'ask-brunon--header'
        : 'side__menu__settings__item flex w-full cursor-pointer flex-row items-center text-left focus-visible:ring-inset'
    "
    @click="toggle"
  >
    <img
      :src="avatarSrc"
      alt=""
      aria-hidden="true"
      class="ask-brunon__avatar"
      draggable="false"
    />
    <p
      v-if="!header"
      :class="{ hidden: !hovered }"
      class="min-w-50 leading-none text-primary-600"
    >
      {{ $t('menu.ask_brunon') }}
    </p>
  </button>
</template>

<script>
import { assistantAvatarSrc } from '~/utils/assistant'

// Sent by widget.js with {ready, open}; the button shows only once ready
const STATE_EVENT = 'laniqo-assistant:state'

export default {
  props: {
    hovered: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggled'],
  setup() {
    const config = useRuntimeConfig()
    return { publicConfig: config.public }
  },
  data() {
    return {
      ready: false,
      open: false,
    }
  },
  computed: {
    avatarSrc() {
      return assistantAvatarSrc(String(this.publicConfig?.assistantUrl || ''))
    },
  },
  mounted() {
    window.addEventListener(STATE_EVENT, this.handleState)
    this.applyState(window.LaniqoAssistant?.state?.())
  },
  beforeUnmount() {
    window.removeEventListener(STATE_EVENT, this.handleState)
  },
  methods: {
    handleState(event) {
      this.applyState(event.detail)
    },
    applyState(state) {
      if (!state) {
        return
      }
      this.ready = state.ready === true
      this.open = state.open === true
    },
    toggle() {
      window.LaniqoAssistant?.toggle()
      this.$emit('toggled')
    },
  },
}
</script>

<style lang="scss" scoped>
.side__menu__settings__item {
  color: var(--color-primary-600);
  background: var(--color-neutral-50);
  // avatar centred in the 5rem menu, label aligned with LogoutButton's
  padding: 0.5rem 1.25rem;
  min-height: 2.75rem;
  line-height: 1;
  font-family: $mainFont;
  font-size: 1rem;
  gap: 0.55rem;
  transition: background 0.3s ease;

  &:hover,
  &:focus-visible {
    background: var(--color-primary-200);
    transition: 0.8s;
  }

  .ask-brunon__avatar {
    width: 2.5rem;
    height: 2.5rem;
  }
}

.ask-brunon__avatar {
  flex-shrink: 0;
  border-radius: 9999px;
  border: 2px solid #fff;
  background: #fff;
  object-fit: cover;
  object-position: top;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}

.ask-brunon--header {
  display: flex;
  cursor: pointer;
  border-radius: 9999px;

  .ask-brunon__avatar {
    width: 2.25rem;
    height: 2.25rem;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-600);
    outline-offset: 2px;
  }
}
</style>
